// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_8t8NmwgcqXjuR4jqsxxl4","row-wrapper":"_3ZooGuiyhssNpAlJzRuepj"};